// modules
import { handleActions } from 'redux-actions'

// actions
import { setUrgentCareReportList } from 'src/store/modules/reports/urgentCareReport'

const initialState = {
  urgentCareReportList: []
}

export default handleActions(
  {
    [setUrgentCareReportList](state, { payload: urgentCareReportList }) {
      return {
        ...state,
        urgentCareReportList
      }
    }
  },
  initialState
)
